import { Dialog } from "@dash/dialog";
import { Button, TextField } from "@dash/form";
import { SelectDialog } from "@dash/select";
import React, { useState } from "react";
import { MdAdd } from "react-icons/md";

import { useClientManager, useServiceClient } from "@megaron/react-clients";
import { Uuid } from "@megaron/uuid";

type Props = {
  customerId: Uuid;
  customerTags: string[];
  onSuccess: () => void;
  onClose: () => void;
};

export const EditTagsDialog: React.FC<Props> = (props) => {
  const saveTags = useClientManager("crm").saveCustomer().useMutation();
  const docs = useServiceClient("docs");

  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [newTag, setNewTag] = useState("");

  const saveCustomerTags = (tags: string[]) => {
    saveTags.mutate(
      {
        tags,
        uuid: props.customerId,
      },
      {
        onSuccess: () => {
          props.onSuccess();
        },
      },
    );
  };

  const handleAddTag = () => {
    const trimmed = newTag.trim();
    if (!trimmed || props.customerTags.includes(trimmed)) return;
    const updated = [...props.customerTags, trimmed];
    saveCustomerTags(updated);
    setNewTag("");
    setIsAddDialogOpen(false);
  };

  return (
    <>
      <SelectDialog
        variant="multi-select"
        noTrigger
        isOpen
        onClose={props.onClose}
        initiallySelectedValues={props.customerTags}
        onSelectedChange={(tags) => {
          const values = tags.map((t) => t.value);
          saveCustomerTags(values);
        }}
        search={async (searchText) => {
          const result = await docs.autocomplete({
            doctype: "customer",
            field: "tags",
            text: searchText,
            limit: 100,
          });

          return result.value?.map((tag) => ({ label: `#${tag}`, value: tag })) ?? [];
        }}
        shouldNotCloseOnSelect
        optionalHeaderRightIcon={<MdAdd style={{ cursor: "pointer" }} onClick={() => setIsAddDialogOpen(true)} />}
      />

      {isAddDialogOpen && (
        <Dialog header="Dodaj nowy tag" onClose={() => setIsAddDialogOpen(false)}>
          <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <TextField value={newTag} onChange={setNewTag} autoFocus />
            <Button onClick={handleAddTag} isDisabled={!newTag.trim()}>
              Zapisz
            </Button>
          </div>
        </Dialog>
      )}
    </>
  );
};
